import { useModal } from "components/ModalGlobal";
import { parseDateBR } from "helpers/date";
import { maskDocument } from "helpers/document";
import React, { useEffect, useMemo, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap";
import AdminRequestService from "services/admin-request";

function TableListCompanies({ list, blockChange, listBlocked }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if(listBlocked.includes(item.id)){
        return false;
      }
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter, listBlocked]);

  return (
    <>
      <label>Lista de empresas</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(1, item.id)}>Bloquear</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function TableBlockedCompanies({ list, blockChange }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter]);

  return (
    <>
      <label>Lista de empresas bloqueadas</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th>Data de bloqueio</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>{parseDateBR(item.created_at)}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(0, item.id)}>Desbloquear</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function Message(){
  const [message, setMessage] = useState({
    message:"",
    loading:true
  })

  useEffect(()=>{
    AdminRequestService.getMessageActionBlockedCompanies().then(({data})=>{
      setMessage({message:data.message,loading:false})
    })
  },[])

  return (
    <textarea style={{width:"100%"}} id="text-area-name-block-action" rows={10} defaultValue={message.message}/>
  );
}

export default function BlockAction({companiesList}) {
  const [list] = useState(companiesList);
  const [listBlocked, setListBlocked] = useState([]);
  const {showModal} = useModal();

  useEffect(() => {
    AdminRequestService.getActionBlockedCompanies().then(({ data }) => {
      setListBlocked(data);
    })
  }, []);

  function blockChange(is_blocked, company_id){
    let formData = new FormData();
    formData.append("is_blocked",is_blocked);
    formData.append("company_id",company_id);

    AdminRequestService.changeBlockAction(formData).then(({data})=>{
      if(is_blocked==1){
        setListBlocked(old=>([...old, data]))
      } else {
        setListBlocked(old=>{
          return old.filter(item=>item.id != data.id);
        })
      }
    })
  }

  return (
    <Container>
      <Row className="justify-content-between align-items-center">
        <Col><h5>Bloqueio de canais para reembolso</h5></Col>
        <Col xs="auto">
          <Row>
            <Col>
              <Button size="sm" onClick={()=>{
                showModal({
                  show: true,
                  title:"Mensagem",
                  body:<Message/>,
                  buttons:[
                    {label:"Salvar",value:1},
                    {label:"Cancelar",value:0,variant:"danger"},
                  ]
                }).then((result)=>{
                  if(result == 1){
                    let ta = document.getElementById("text-area-name-block-action");
                    if(ta){
                      AdminRequestService.setMessageActionBlockedCompanies(ta.value).then(()=>{
                        // console.log("salvo")
                      })
                    }
                  }
                });
              }}>Mudar mensagem</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <hr />
      <TableBlockedCompanies list={listBlocked} blockChange={blockChange}/>
      <TableListCompanies list={list} blockChange={blockChange} listBlocked={listBlocked.map(item=>item.id)}/>
    </Container>
  );
}